module.exports = __webpack_public_path__ + "static/media/grid-jpg4.46583e32.jpg";